import Vue from 'vue'

export default function createEventBus() {
  return new Vue()
}
